exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#TerminalsRegister .v--modal-box.v--modal{min-height:360px!important;min-width:800px!important}#TerminalsRegister .modal__content{overflow-y:hidden!important}#TerminalsRegister .modal__footer{display:none}#TerminalsRegister .modal__content{height:calc(100% - 60px)!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-535d06d1","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/start/modals/terminals/TerminalsRegister.vue
// module id = 2053
// module chunks = 0